module.exports = __webpack_public_path__ + "static/media/submenu-contagem.24226c47.svg";